// THE "NEW GROUP" OPTION every group-name picker offers (owner, 2026-10-23 —
// D-411: "'New Group: [content]' always appears as an option and fills-in as I
// type. That would make it more clear that these fields accept new values,
// beyond those listed."). First in the list, before a single key is typed, and
// following the typing after; picking it with nothing typed does nothing.

/** What a person sees: the label, then whatever they have typed so far. */
export function newGroupLabel(typed: string): string {
  return `New Group: ${typed}`
}

/** The search text a name is read from: trimmed, its inner spaces collapsed. */
export function typedGroupName(term: string): string {
  return term.trim().replace(/\s+/g, ' ')
}
